// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"332":"detail","962":"home"}[chunkId] + "." + {"332":"9d4977c8","962":"415bd949"}[chunkId] + ".css";
};